// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"671":"services","933":"auth","945":"dashboard"}[chunkId] + "." + {"671":"49ea78ea","933":"d05a9840","945":"5fe87467"}[chunkId] + ".js";
};